import {
  Captcha,
  BrandPayoutRankingItem,
  CreateCustomExpenseDto,
  CustomExpenseEntity,
  CustomExpenseOccurrenceEntity,
  FinancesComparedOverviewEntity,
  FinancesDeliveryLossEntity,
  FinancesGamesEntity,
  FinancesGamesPlayerEntity,
  FinancesLossOrderEntity,
  FinancesOverviewEntity,
  FinancesSaasDetailsEntity,
  FinancesSaasPaymentEntity,
  FinancesServiceFeeDetailsEntity,
  FinancesTopIncomeLocationEntity,
  GetFinancesBrandRankingParams,
  GetFinancesComparedOverviewParams,
  GetFinancesGamesParams,
  GetFinancesGamesPlayersParams,
  GetFinancesListParams,
  GetFinancesOverviewParams,
  GetFinancesSaasDetailsParams,
  GetFinancesSaasPaymentsParams,
  GetFinancesServiceFeeDetailsParams,
  PaginationParams,
  ResponseType,
  SaasEligibleLocation,
  TransactionStatus,
  UpdateCustomExpenseDto,
  UpdateCustomExpenseOccurrenceDto,
  VPayBalanceResponse,
} from '../types';
import {
  BestPerformingBrandsEntity,
  BestPerformingLocationsEntity,
  BestPerformingProviderEntity,
  BestPerformingStateEntity,
  CustomersOverviewEntity,
  ComparedOrdersOverviewEntity,
  ComparedDeliveriesOverviewEntity,
  DeliveriesTodayInfoEntity,
  DeliveriesOverviewEntity,
  OrdersOverviewEntity,
  OrdersTodayInfoEntity,
  BestPerformingFleetEntity,
  ClientsOverHundredEntity,
  SuccessRateEntity,
  FinancesWithdrawalEntity,
  TrackingSuccessRateEntity,
} from '../types/brandOwner';
import {
  GetDashboardComparedOverviewParams,
  GetDashboardOverviewParams,
  GetDashboardTodayParams,
  GetDashboardWorstPerformingLocationsFilterParams,
} from '../types/dashboard.types';
import { api } from './api';

//ORDERS

export const getDashboardOverview = (params: GetDashboardOverviewParams) =>
  api.get<ResponseType<OrdersOverviewEntity>>(`/v2/dashboard/orders/overview`, {
    params,
  });

export const getDashboardComparedOverview = (
  params: GetDashboardComparedOverviewParams
) =>
  api.get<ResponseType<ComparedOrdersOverviewEntity>>(
    `/v2/dashboard/orders/compared-overview`,
    {
      params,
    }
  );

export const getDashboardOrdersToday = (params: GetDashboardTodayParams) =>
  api.get<ResponseType<OrdersTodayInfoEntity>>(`/v2/dashboard/orders/today`, {
    params,
  });

export const getDashboardBestPerformingLocations = (params: PaginationParams) =>
  api.get<ResponseType<BestPerformingLocationsEntity[]>>(
    `/v2/dashboard/orders/best-performing-locations`,
    {
      params,
    }
  );

export const getDashboardBestPerformingStates = (params: PaginationParams) =>
  api.get<ResponseType<BestPerformingStateEntity[]>>(
    `/v2/dashboard/orders/best-performing-states`,
    {
      params,
    }
  );

export const getDashboardBestPerformingBrands = (params: PaginationParams) =>
  api.get<ResponseType<BestPerformingBrandsEntity[]>>(
    `/v2/dashboard/orders/best-performing-brands`,
    {
      params,
    }
  );

export const getDashboardBestPerformingProviders = (params: PaginationParams) =>
  api.get<ResponseType<BestPerformingProviderEntity[]>>(
    `/v2/dashboard/orders/best-performing-providers`,
    {
      params,
    }
  );

export const getDashboardCustomerOverview = () =>
  api.get<ResponseType<CustomersOverviewEntity>>(
    `/v2/dashboard/orders/customers-overview`
  );

//DELIVERIES

export const getDashboardDeliveriesOverview = (
  params: GetDashboardOverviewParams
) =>
  api.get<ResponseType<DeliveriesOverviewEntity>>(
    `/v2/dashboard/deliveries/overview`,
    {
      params,
    }
  );

export const getDashboardComparedDeliveriesOverview = (
  params: GetDashboardComparedOverviewParams
) =>
  api.get<ResponseType<ComparedDeliveriesOverviewEntity>>(
    `/v2/dashboard/deliveries/compared-overview`,
    {
      params,
    }
  );

export const getDashboardDeliveriesToday = (params: GetDashboardTodayParams) =>
  api.get<ResponseType<DeliveriesTodayInfoEntity>>(
    `/v2/dashboard/deliveries/today`,
    {
      params,
    }
  );

export const getDashboardBestPerformingLocationsDeliveries = (
  params: PaginationParams
) =>
  api.get<ResponseType<BestPerformingLocationsEntity[]>>(
    `/v2/dashboard/deliveries/best-performing-locations`,
    {
      params,
    }
  );

export const getDashboardWorstPerformingLocationsDeliveries = (
  params: PaginationParams
) =>
  api.get<ResponseType<BestPerformingLocationsEntity[]>>(
    `/v2/dashboard/deliveries/worst-performing-locations`,
    {
      params,
    }
  );

export const getDashboardWorstPerformingLocationsFilterDeliveries = (
  params: PaginationParams & GetDashboardWorstPerformingLocationsFilterParams
) =>
  api.get<ResponseType<BestPerformingLocationsEntity[]>>(
    `/v2/dashboard/deliveries/worst-performing-locations-filter`,
    {
      params,
    }
  );

export const getDashboardBestPerformingStatesDeliveries = (
  params: PaginationParams
) =>
  api.get<ResponseType<BestPerformingStateEntity[]>>(
    `/v2/dashboard/deliveries/best-performing-states`,
    {
      params,
    }
  );

export const getDashboardBestPerformingFleetsDeliveries = (
  params: PaginationParams
) =>
  api.get<ResponseType<BestPerformingFleetEntity[]>>(
    `/v2/dashboard/deliveries/best-performing-fleets`,
    {
      params,
    }
  );

export const getDashboardSuccessRateDeliveries = () =>
  api.get<ResponseType<SuccessRateEntity>>(
    `/v2/dashboard/deliveries/success-rate`
  );

export const getDashboardTrackingSuccessRateDeliveries = () =>
  api.get<ResponseType<TrackingSuccessRateEntity>>(
    `/v2/dashboard/deliveries/tracking-success-rate`
  );

export const getDashboardTotalBlueCardBalanceFinances = (
  params: PaginationParams
) =>
  api.get<ResponseType<ClientsOverHundredEntity[]>>(
    `/v2/dashboard/finances/total-blue-card-balance`,
    {
      params,
    }
  );

export const getDashboardVPayBalanceFinances = () =>
  api.get<ResponseType<VPayBalanceResponse>>(
    `/v2/dashboard/finances/vpay-balance`
  );

export const getDashboardTotalBlueCardWithdrawalFinances = (
  params: PaginationParams & { status: TransactionStatus }
) =>
  api.get<ResponseType<FinancesWithdrawalEntity[]>>(
    `/v2/dashboard/finances/total-blue-card-withrawal`,
    {
      params,
    }
  );

export const getDashboardClientsOverHundredFinances = (
  params: PaginationParams & { amount: number }
) =>
  api.get<ResponseType<ClientsOverHundredEntity[]>>(
    `/v2/dashboard/finances/clients-over-hundred`,
    {
      params,
    }
  );

export const getDashboardClientsOverHundredCountFinances = (
  params: PaginationParams & { amount: number }
) =>
  api.get<ResponseType<{ count: number }>>(
    `/v2/dashboard/finances/clients-over-hundred-count`,
    {
      params,
    }
  );

export const postDashboardVPayAddBalanceFinances = (params: {
  amount: number;
  adminPassword: string;
  captcha: Captcha;
}) =>
  api.post<ResponseType<VPayBalanceResponse>>(
    `/v2/dashboard/finances/vpay/add-balance`,
    params
  );

// FINANCES (Net Profit (P&L) overview, comparison, loss orders, top income locations, top loss brands)

export const getFinancesOverview = (params: GetFinancesOverviewParams) =>
  api.get<ResponseType<FinancesOverviewEntity>>(`/v1/finances`, { params });

export const getFinancesComparedOverview = (
  params: GetFinancesComparedOverviewParams
) =>
  api.get<ResponseType<FinancesComparedOverviewEntity>>(
    `/v1/finances/compare`,
    { params }
  );

export const getFinancesLossOrders = (params: GetFinancesListParams) =>
  api.get<ResponseType<FinancesLossOrderEntity[]>>(`/v1/finances/loss-orders`, {
    params,
  });

export const getFinancesDeliveryLosses = (params: GetFinancesListParams) =>
  api.get<ResponseType<FinancesDeliveryLossEntity[]>>(
    `/v1/finances/delivery-losses`,
    { params }
  );

/** What "Monthly Saas" is made of: monthly payments and per-order charges. */
export const getFinancesSaasDetails = (params: GetFinancesSaasDetailsParams) =>
  api.get<ResponseType<FinancesSaasDetailsEntity>>(
    `/v1/finances/saas-details`,
    { params }
  );

/** Monthly SaaS payments, newest first. A short page means the end. */
export const getFinancesSaasPayments = (
  params: GetFinancesSaasPaymentsParams
) =>
  api.get<ResponseType<FinancesSaasPaymentEntity[]>>(
    `/v1/finances/saas-details/payments`,
    { params }
  );

/** Where "Service Fee" came from: card vs cash, by partner and by location. */
export const getFinancesServiceFeeDetails = (
  params: GetFinancesServiceFeeDetailsParams
) =>
  api.get<ResponseType<FinancesServiceFeeDetailsEntity>>(
    `/v1/finances/service-fee-details`,
    { params }
  );

/** The MyChips games on the tracker: what they paid and how it split. Admin only. */
export const getFinancesGames = (params: GetFinancesGamesParams) =>
  api.get<ResponseType<FinancesGamesEntity>>(`/v1/finances/games`, {
    params,
  });

/** The players, biggest `revenue` first. A short page means the end. */
export const getFinancesGamesPlayers = (
  params: GetFinancesGamesPlayersParams
) =>
  api.get<ResponseType<FinancesGamesPlayerEntity[]>>(
    `/v1/finances/games/players`,
    { params }
  );

export const getFinancesTopIncomeLocations = (params: GetFinancesListParams) =>
  api.get<ResponseType<FinancesTopIncomeLocationEntity[]>>(
    `/v1/finances/top-income-locations`,
    { params }
  );

export const getFinancesBrandRanking = (
  params: GetFinancesBrandRankingParams
) =>
  api.get<ResponseType<BrandPayoutRankingItem[]>>(
    `/v1/finances/brand-ranking`,
    { params }
  );

/**
 * Locations that pay no SaaS fee but would qualify for one, by `total`,
 * highest first. Always the last 30 days from now: it takes no from/to.
 */
export const getFinancesSaasEligibleLocations = () =>
  api.get<ResponseType<SaasEligibleLocation[]>>(
    `/v1/finances/saas-eligible-locations`
  );

// FINANCES — Custom (admin-managed) operating expenses CRUD

export const getFinancesCustomExpenses = () =>
  api.get<ResponseType<CustomExpenseEntity[]>>(`/v1/finances/custom-expenses`);

export const postFinancesCustomExpense = (body: CreateCustomExpenseDto) =>
  api.post<ResponseType<CustomExpenseEntity>>(
    `/v1/finances/custom-expenses`,
    body
  );

export const patchFinancesCustomExpense = (
  id: number,
  body: UpdateCustomExpenseDto
) =>
  api.patch<ResponseType<CustomExpenseEntity>>(
    `/v1/finances/custom-expenses/${id}`,
    body
  );

export const deleteFinancesCustomExpense = (id: number) =>
  api.delete<ResponseType<null>>(`/v1/finances/custom-expenses/${id}`);

export const getFinancesCustomExpenseOccurrences = (id: number) =>
  api.get<ResponseType<CustomExpenseOccurrenceEntity[]>>(
    `/v1/finances/custom-expenses/${id}/occurrences`
  );

export const patchFinancesCustomExpenseOccurrence = (
  id: number,
  body: UpdateCustomExpenseOccurrenceDto
) =>
  api.patch<ResponseType<CustomExpenseOccurrenceEntity>>(
    `/v1/finances/custom-expense-occurrences/${id}`,
    body
  );

export const deleteFinancesCustomExpenseOccurrence = (id: number) =>
  api.delete<ResponseType<null>>(
    `/v1/finances/custom-expense-occurrences/${id}`
  );
